<template>
  <require from="framework/html_behaviors/af-movable"></require>
  <require from="framework/html_behaviors/af-details.html"></require>
  <require from="./dialog-styles.css"></require>

  <ux-dialog class="af-dialog ${class}" af-movable.bind="header">
    <ux-dialog-header ref="header">
      ${dialogTitle}
    </ux-dialog-header>
    <ux-dialog-body>
      <div class="af-dialog__icon" if.bind="icon != null"><i class.bind="icon"></i></div>
      <div class="af-dialog__main" as-element="af-details" message.bind="message" details.bind="details"></div>
    </ux-dialog-body>
    <ux-dialog-footer>
      <button type="button" click.delegate="ok()">${okTitle}</button>
      <button type="button" click.delegate="cancel()" attach-focus="true">${cancelTitle}</button>
    </ux-dialog-footer>
  </ux-dialog>
</template>
